import { render, staticRenderFns } from "./ReminderList.vue?vue&type=template&id=183ddd76&"
import script from "./ReminderList.vue?vue&type=script&lang=ts&"
export * from "./ReminderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports